import {
  RPATaskRequest,
  RPATaskResponse,
} from "../../../medonc/data-model/rpaTaskQueue";
import { logDataToConsole } from "../../../medonc/utils/customLogger";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export const sendRpaRequestsToRabbitMq = async (
  path: string,
  request: RPATaskRequest,
): Promise<RPATaskResponse> => {
  try {
    const baseUrl = `${API_ENDPOINTS.RPA_TASK_QUEUE}/${path}`;
    const token = await getBearerToken();
    if (!token) {
      return { success: false, message: "Bearer token not available" };
    }
    const response = await fetch(baseUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(request),
    });
    if (!response.ok) {
      return {
        success: false,
        message: `Request failed with status ${response.status}`,
      };
    }
    const data = await response.json();
    return {
      success: true,
      message: data.message ?? "Request successful",
      identifier: data.identifier,
    };
  } catch (error) {
    logDataToConsole("error in sendRpaRequestsToRabbitMq", error);
    return {
      success: false,
      message:
        error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};
